var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c("div", { staticClass: "card setting-card" }, [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("funders.billing_address"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("funders.name"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder &&
          _vm.viewFunder.billing_address &&
          _vm.viewFunder.billing_address.name != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewFunder.billing_address.name))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("funders.country"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder &&
          _vm.viewFunder.billing_address &&
          _vm.viewFunder.billing_address.country != null
            ? _c("p", [
                _vm._v(_vm._s(_vm.viewFunder.billing_address.country.name)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("funders.state"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder &&
          _vm.viewFunder.billing_address &&
          _vm.viewFunder.billing_address.state != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewFunder.billing_address.state))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("funders.city"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder &&
          _vm.viewFunder.billing_address &&
          _vm.viewFunder.billing_address.city != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewFunder.billing_address.city))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("general.street_1"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder &&
          _vm.viewFunder.billing_address &&
          _vm.viewFunder.billing_address.address_street_1 != null
            ? _c("p", [
                _vm._v(_vm._s(_vm.viewFunder.billing_address.address_street_1)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("general.street_2"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder &&
          _vm.viewFunder.billing_address &&
          _vm.viewFunder.billing_address.address_street_2 != null
            ? _c("p", [
                _vm._v(_vm._s(_vm.viewFunder.billing_address.address_street_2)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("funders.phone"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder &&
          _vm.viewFunder.billing_address &&
          _vm.viewFunder.billing_address.phone != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewFunder.billing_address.phone))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("funders.zip_code"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder &&
          _vm.viewFunder.billing_address &&
          _vm.viewFunder.billing_address.zip != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewFunder.billing_address.zip))])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }